import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {InsightsService} from '../service/insights.service'
import { MAT_DIALOG_DATA } from "@angular/material/dialog"; 
import { NotifierService } from 'angular-notifier';
// import { I } from "@angular/cdk/keycodes";
// declare let html2canvas: any;
// import html2canvas from 'html2canvas';
@Component({
    selector: "app-voc-intro",
    templateUrl: "./voc-intro.html",
    styleUrls: ['./voc-intro.css'],
})

export class VocIntroComponent implements OnInit {
    public vocdescTitle: number = 1;
    public title:string ="";
    public subtitle=[];
    public count_subtitle_arr = [];
    public ErrorShow:string = "";
    public screenOrigin:string;
    

    constructor(private dialoge:MatDialog,public iService:InsightsService,@Inject(MAT_DIALOG_DATA) public data:any,public notify:NotifierService) { 
       this.screenOrigin = data.type;
    }
    ngOnInit() { 
        if(this.screenOrigin == 'club_voc_edit'){
            const screenEditObj = this.iService.VOCsToBeClub.vocs[this.data['editIndex']];
            if(screenEditObj.preview){
                this.iService.vocIntroFormtitle = screenEditObj.preview.title;
                if(screenEditObj.preview.text.length>0){
                    this.iService.vocIntroFormSubtitle = [];
                    screenEditObj.preview.text.forEach((scn) => {
                        this.iService.vocIntroFormSubtitle.push({value:scn});
                    })
                }
            }
        }
    }
    DialogeClose = () => {
        if(this.screenOrigin == 'club_voc_edit'){
            this.iService.vocIntroFormSubtitle = [{value:""}];
            this.iService.vocIntroFormtitle = "";
            this.dialoge.closeAll();
        }
        else{
            if(this.iService.isvocEditFormSubmit && !this.iService.isvocadd)
            {
                //this.iService.vocIntroFormSubtitle = this.iService.copyvocIntroFormSubtitle;
                if(!this.iService.copyvocIntroFormSubtitle.length)
                {
                    this.iService.vocIntroFormSubtitle = [{value:""}];
                }
                else
                {
                    let arr = [];
                    this.iService.copyvocIntroFormSubtitle.forEach((va) => arr.push({value:va}));
                    this.iService.vocIntroFormSubtitle = arr;
                }
                this.iService.vocIntroFormtitle = this.iService.copyvocIntroFormtitle;
                //this.iService.isvocadd = true;
                this.dialoge.closeAll();
                // console.log(this.iService.copyvocIntroFormSubtitle,'KKKKKK');
            }
            else if(!this.iService.isvocEdit)
            {
                this.iService.isvocadd = true;
                this.iService.vocIntroFormSubtitle = [{value:""}];
                this.iService.vocIntroFormtitle = "";
                this.dialoge.closeAll();
            }
            else
            {
                this.dialoge.closeAll();
            }
        }
        
    }
   
    addvocdesInc = (n: number,str:string,v:number = 0) => {
        if (this.vocdescTitle < 5) {
            this.vocdescTitle += n;
        }
        if(str == 'remove')
        {
            this.iService.vocIntroFormSubtitle.splice(v,1);
        }
        if(str == 'add')
        {
            this.iService.vocIntroFormSubtitle.push({value:""});
        }
    }
   
    SubmitData = () =>
    {
        if(this.iService.vocIntroFormtitle === "")
        {
            this.ErrorShow = 'Please Enter The Title'
        }
        else
        {
            //console.log(this.iService.vocIntroFormSubtitle,'Hiiiiii');
            this.iService.copyvocIntroFormtitle = this.iService.vocIntroFormtitle;
            let arr = [];
            for(let i of this.iService.vocIntroFormSubtitle)
            {
                if(i.value)
                {
                    arr.push(i.value);
                }
            }
            if(this.screenOrigin == 'club_voc'){
                this.iService.createScreen();
            }
            else if(this.screenOrigin == 'club_voc_edit'){
                this.iService.VOCsToBeClub.vocs[this.data['editIndex']]['preview']['title'] = this.iService.vocIntroFormtitle;
                this.iService.VOCsToBeClub.vocs[this.data['editIndex']]['preview']['text'] = [];
                this.iService.vocIntroFormSubtitle.forEach((sub) => {
                    if(sub.value != ''){
                        this.iService.VOCsToBeClub.vocs[this.data['editIndex']]['preview']['text'].push(sub.value);
                    }
                })
                this.iService.vocIntroFormtitle = "";
                this.iService.vocIntroFormSubtitle = [{value:""}];
            }
            else{
                this.iService.isvocEdit = true;
                this.iService.isvocadd = false;
            }
            this.iService.copyvocIntroFormSubtitle = arr;
            this.dialoge.closeAll();
            this.ErrorShow = "";
        }
       
    }

   

}